import type { MarketingSnapshot } from '../api/marketingViews';
export const MARKETING_VIEW_PAGES = new Set([
  'site-data/channel-portal', 'site-data/cost-type-monitoring', 'site-data/target-type-layered',
  'site-data/delivery-target', 'site-data/channel-acquisition', 'site-data/traffic-monitoring',
  'site-data/bounce-rate', 'site-data/user-portal', 'ad-analysis/sku-roi', 'ad-analysis/channel-wide-table',
  'ad-analysis/acquisition-cost', ...['google', 'meta', 'tiktok', 'snapchat', 'bing', 'criteo', 'applovin', 'rtb'].map(platform => 'ad-analysis/ad-dashboard/' + platform),
]);
export function viewPage(path: string) { return path.split('?')[0].replace(/^\//, ''); }
export function viewFingerprint(value: unknown): string {
  if (Array.isArray(value)) return '[' + value.map(viewFingerprint).join(',') + ']';
  if (value && typeof value === 'object') return '{' + Object.entries(value).sort(([a], [b]) => a.localeCompare(b)).map(([key, item]) => JSON.stringify(key) + ':' + viewFingerprint(item)).join(',') + '}';
  return JSON.stringify(value) ?? 'null';
}
export function isMarketingSnapshot(value: unknown): value is MarketingSnapshot {
  if (!value || typeof value !== 'object') return false;
  const snapshot = value as MarketingSnapshot;
  return snapshot.version === 1 && !!snapshot.sections && typeof snapshot.sections === 'object' && !Array.isArray(snapshot.sections);
}
/** Validate stored scalar/container types before any section is changed. Empty filter maps allow dynamic keys. */
export function matchesViewShape(value: unknown, template: unknown): boolean {
  if (template === null) return value === null || typeof value === 'object';
  if (Array.isArray(template)) return Array.isArray(value) && (!template.length || value.every(item => matchesViewShape(item, template[0])));
  if (template && typeof template === 'object') return !!value && typeof value === 'object' && !Array.isArray(value)
    && Object.entries(template).every(([key, item]) => matchesViewShape((value as Record<string, unknown>)[key], item));
  return typeof value === typeof template;
}

export function validViewDates(value: unknown): boolean {
  if (!value || typeof value !== 'object') return true;
  if (Array.isArray(value)) return value.every(validViewDates);
  const record = value as Record<string, unknown>;
  const pairs = [['start', 'end'], ['startDate', 'endDate'], ['start_date', 'end_date'], ['customStart', 'customEnd'], ['trendStart', 'trendEnd'], ['tableStart', 'tableEnd'], ['acqStart', 'acqEnd']];
  for (const [start, end] of pairs) {
    if (typeof record[start] !== 'string' || typeof record[end] !== 'string') continue;
    const a = record[start] as string; const b = record[end] as string;
    if (!/^\d{4}-\d{2}-\d{2}$/.test(a) || !/^\d{4}-\d{2}-\d{2}$/.test(b) || a > b || Number.isNaN(Date.parse(a)) || Number.isNaN(Date.parse(b))) return false;
  }
  return Object.values(record).every(validViewDates);
}
